import isPlainObject from "../objects/isPlainObject";

type SessionReplayHandleOptions = {
  enabled?: boolean;
};

type SessionReplayHandle = { sessionReplay: boolean };

export function sessionReplayHandle({
  enabled = true,
}: SessionReplayHandleOptions = {}): SessionReplayHandle {
  return { sessionReplay: enabled };
}

export function hasSessionReplay(handle: unknown) {
  return isPlainObject(handle) && handle.sessionReplay === true;
}
